import { NoteInputTypeEnum } from '@lon/mathnation-suit/requests';

export const COURSEWORK_TYPE = 'form-inputs';

export const NoteEnumTypes = {
  text: NoteInputTypeEnum.Input,
  radio: NoteInputTypeEnum.Radio,
  checkbox: NoteInputTypeEnum.Checkbox,
};
